import { Injectable } from "@angular/core";
import {
    CanActivate,
    Router
} from "@angular/router";
import { LocalStorageService } from '../local-storage/local-storage.service';


@Injectable({
    providedIn: "root"
})
export class AuthGuard implements CanActivate {
    constructor(
        private storageService: LocalStorageService,
        private router: Router,
    ) { }

    canActivate(): boolean {
        if (this.storageService.loggedInUser) {
            return true;
        } else {
            this.router.navigate(["/"]);
            return false;
        }
    }
}
